import { type FC } from 'react';

import ImageComponent from '@vakantiesnl/image-component';
import { type ContentfulImageParams } from '@vakantiesnl/image-component/src/loaders/contentful';

import useStyles from './HeaderImage.styles';

interface Props {
	imageSource: string;
	alt: string;
	className?: string;
}

const contentfulParams: ContentfulImageParams = {
	fm: 'webp',
	w: 856 * 2,
	h: 210 * 2,
	fit: 'fill',
	disableScaling: true,
	f: 'left',
};

export const HeaderImage: FC<Props> = ({ className, imageSource, alt }) => {
	const { classes: styles, cx } = useStyles();

	return (
		<div className={cx(styles.container, className)}>
			<div className={styles.headerImageContainer}>
				<ImageComponent
					useLoader="Contentful"
					contentfulParams={contentfulParams}
					className={styles.headerImage}
					src={imageSource}
					width={856}
					height={210}
					priority
					alt={alt}
				/>
			</div>
		</div>
	);
};
